import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, MouseEventHandler, ReactElement } from 'react';

import { IcQuote16Icon } from '@gem/icons';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import { Quote } from 'STORE/Messages/Message/Quote/Quote';

import { MiniatureMessageLayout } from '../MiniatureMessageLayout/MiniatureMessageLayout';
import styles from './MiniatureQuotedMessage.styles.m.css';

interface IMiniatureQuotedMessageProps {
  titleClassName?: string;
  textClassName?: string;
  iconClassName?: string;
  quote: Quote | null;
  title: string | ReactElement;
  onClick?: MouseEventHandler;
  preventInteraction?: boolean;
  isTextExpanded?: boolean;
}

export const MiniatureQuotedMessage: FC<IMiniatureQuotedMessageProps> = observer((props) => {
  if (!props.quote) {
    return null;
  }

  const containerClassName = classNames(styles.container, {
    [styles.textExpanded]: props.isTextExpanded,
  });

  return (
    <MiniatureMessageLayout
      titleClassName={props.titleClassName}
      textClassName={props.textClassName}
      iconClassName={props.iconClassName}
      className={containerClassName}
      title={props.title}
      messageId={props.quote.messageId || ''}
      onClick={props.onClick}
      preventInteraction={props.preventInteraction}
      preventFocusOnClick
    >
      <div className={styles.content}>
        <span className={styles.iconWrapper}>
          <IconView
            Icon={IcQuote16Icon}
            size={IconViewSizes.Small}
            className={classNames(styles.icon, props.iconClassName)}
          />
        </span>
        <p className={classNames(styles.text, props.textClassName)}>{props.quote.text}</p>
      </div>
    </MiniatureMessageLayout>
  );
});
